import Page from 'components/layout/Page';
import { useI18n } from 'hooks/useI18n';
import { Element } from 'react-scroll';
import Candidates from './components/candidates/Candidates';
import DurationAndCosts from './components/durationAndCosts/DurationAndCosts';
import StateOfHiringHero from './components/hero/StateOfHiringHero';
import StateOfHiringIntro from './components/intro/StateOfHiringIntro';
import Methodology from './components/methodology/Methodology';
import SuccessRate from './components/successRate/SuccessRate';

type SectionProps = {
  section: string;
  tooltip: string;
};

const StateOfHiringComponent: React.FC = () => {
  //const { locale } = useRouter();
  const { t } = useI18n('state-of-hiring');

  const sections: SectionProps[] = [
    { section: 'intro', tooltip: t('state-of-hiring.nav.intro') },
    {
      section: 'duration-and-costs',
      tooltip: t('state-of-hiring.nav.time-to-hire')
    },
    { section: 'success-rate', tooltip: t('state-of-hiring.nav.success-rate') },
    { section: 'candidates', tooltip: t('state-of-hiring.nav.candidates') },
    { section: 'methodology', tooltip: t('state-of-hiring.nav.methodology') }
  ];

  return (
    <Page pageVariant="light" hasScrollTop sections={sections}>
      <StateOfHiringHero />
      <Element name="intro" id="intro">
        <StateOfHiringIntro />
      </Element>
      <Element name="duration-and-costs" id="duration-and-costs">
        <DurationAndCosts />
      </Element>
      <Element name="success-rate" id="success-rate">
        <SuccessRate />
      </Element>
      <Element name="candidates" id="candidates">
        <Candidates />
      </Element>
      <Element name="methodology" id="methodology">
        <Methodology />
      </Element>
    </Page>
  );
};

export default StateOfHiringComponent;
